import React from "react";
const PopupMessage = (props) => {
  
  return (
    <>
      <div className="popup-overlay modal-notify">
        <div className="popup-warp">
          <div className="icon-popup"></div>
          <div className="popup-inner">
            <div className="content-popup">
              <h4>Thông báo</h4>
              <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
            </div>
            {props.nameBtn2 && props.nameBtn1 && (
              <div className="group-btn-inline">
                <button
                  type="button"
                  className="btn btn-primary btn-border btn-block"
                  onClick={props.clickAction1}
                >
                  <a dangerouslySetInnerHTML={{ __html: props.nameBtn1 }}></a>
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={props.clickAction2}
                >
                  <a dangerouslySetInnerHTML={{ __html: props.nameBtn2 }}></a>
                </button>
              </div>
            )}
            {props.nameBtn && (
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={props.clickAction}
              >
                <a dangerouslySetInnerHTML={{ __html: props.nameBtn }}></a>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupMessage;
